export default __webpack_public_path__ + "static/media/quiz-pic-6.9ebd55d0.jpeg";